import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ReactSearchAutocomplete } from 'react-search-autocomplete';

import Cookies from "js-cookie";

import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';

import { Mensagem } from "../../../pages/AlertaExpedicao/utils/mensagem";
import { api } from '../../../services/Api';
import { AuthContext } from '../../../store/AuthContext';
import ToastCustomizado from "../../Toast";

import './index.css';
import { montaMenssagemRetornoErroPromiseAllSettled } from "../../../util/FuncoesComuns";

const initialUnidade = {
  id: 0,
  mcmcu: "",
  codigoSro: "",
  nome: "",
  name: "",
  se: "",
  codigoSe: ""
}

const AlterarUnidade = () => {

  const navigate = useNavigate()
  const [show, setShow] = useState<boolean>(false);
  const { user, setUser, setErro } = useContext(AuthContext);
  const [mensagem, setMensagem] = useState<Mensagem>({ delay: 5000, tipo: '', texto: '', url: '/alterar-unidade' });
  const [unidades, setUnidades] = useState([initialUnidade]);
  const [unidadeSelecionada, setUnidadeSelecionada] = useState(initialUnidade);

  useEffect(() => {

    (async function () {

      const complemento = !user || (user && (user.isAdministrador || user?.dr === 'CS')) ? '' : `?codigoSe=${user && user.funcionario && user.funcionario.siglaDR ? user.funcionario.siglaDR : 'CS'}`;

      const [retorno] = await Promise.allSettled([api.get(`v1/unidades/lista-nomes${complemento}`)]);

      if (retorno.status === 'fulfilled') {
        let res = await retorno.value.data;
        res = res.map((u:string) => ({id: Number(u.split(' - ')[0]), codigoSro: u.split('-')[0].trim(), name: u}));
        setUnidades(res);
      } else if (retorno.status === 'rejected') {
        setErro({ delay: 5000, tipo: 'danger', texto: montaMenssagemRetornoErroPromiseAllSettled(retorno, 'Erro ao chamar v1/unidades/todas - Rejeitado.'), url: '/erro' });
        navigate('/erro')
      } else {
        setErro({ delay: 5000, tipo: 'danger', texto: `Alerta : Erro ao chamar v1/unidades/todas - Contacte o Adminitrador!`, url: '/erro' });
        navigate('/erro')
      }
    })();
   //eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  useEffect(() => {

    //Limpar o input campo de pesquisa
    if (JSON.stringify(unidadeSelecionada) !== JSON.stringify(initialUnidade)) {

      setTimeout(() => setUnidadeSelecionada(initialUnidade), 0.1);

      const btn = document.getElementsByClassName('clear-icon')[0] as HTMLElement | null;
      //Click para limpar os inputs de unidade selecionada
      if (btn != null) {
        btn.click();
      }

    }
  //eslint-disable-next-line react-hooks/exhaustive-deps
  },[user]);


  const handleOnSelect = (item: any) => {
    // the item selected
    setUnidadeSelecionada(item)
  }

  const formatResult = (item: any) => {
    return (
      <>
        <span className='item-nome text-left'>{item.name}</span>
      </>
    )
  }

  const manteruser = (evento: React.MouseEvent<HTMLButtonElement>) => {
    evento.preventDefault()
    const userSro = api.post('v1/empregados', {
      matricula: user?.sub,
      nome: user?.nome,
      codSroOrigem: unidadeSelecionada.codigoSro,
      cargo: 'Carteiro' //user?.funcao
    });
    userSro.then((u) => {

      if (user) {
        setUser({ ...user, unidadeSro: u.data.unidade });

        let storageMenuUnidade = Cookies.get('hash_u');

        if (storageMenuUnidade) {
          let decoded = JSON.parse(storageMenuUnidade);
          decoded.unidadeSro = u.data.unidade;
          Cookies.set('hash_u', JSON.stringify(decoded), { secure: true })

        }

        setMensagem({ ...mensagem, delay: mensagem.delay === 5000 ? 5001 : 5000, tipo: 'info', texto: `Ok : Unidade alterada com sucesso.` });
        setShow(true)
      }

    }).catch((error) => {
      setErro({ delay: 5000, tipo: 'danger', texto: `Problema em alterar unidade: ${String(error)}`, url: '/erro'});
      navigate('/erro')
    })



  };


  return (

    <>
      <Breadcrumb>
            <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>Home</Breadcrumb.Item>
            <Breadcrumb.Item active>{'Unidade de Trabalho'}</Breadcrumb.Item>
      </Breadcrumb>

      <Row className="text-center mt-5 mb-3"><h1>{user && user.unidadeSro ? 'Alterar Unidade de Trabalho' : 'Obrigatório selecionar sua Unidade de Trabalho'}</h1></Row>
      <Row className="row-alterar-unidade">
        <Col xl={3} lg={8} md={12}>

          <Form>

            <Form.Group className="sm-2  mb-3" controlId="exampleForm.ControlInput1">
              <ReactSearchAutocomplete
                items={unidades}
                placeholder="Nome ou Código SRO da Unidade"
                showNoResultsText="Nenhum registro encontrado."
                onSelect={handleOnSelect}
                autoFocus={true}
                maxResults={50}
                fuseOptions={{  threshold: 0.15, keys: ["name"] }}
                resultStringKeyName="name"
                formatResult={formatResult}
                styling={{
                  border: "1px solid #ced4da",
                  borderRadius: "0.375rem",
                  fontSize: "1rem",
                }}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
              <Form.Label>Unidade selecionada*</Form.Label>
              <Form.Control type="text" value={unidadeSelecionada?.name}
                disabled
                readOnly />
            </Form.Group>
            <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
              <Form.Label>Codigo SRO selecionado</Form.Label>
              <Form.Control type="text" value={unidadeSelecionada?.codigoSro}
                disabled
                readOnly />
            </Form.Group>
            <Button variant="primary" disabled={!unidadeSelecionada || (unidadeSelecionada && unidadeSelecionada.codigoSro === '')} onClick={(e) => manteruser(e)}>Salvar</Button>{' '}
            <Button variant="secondary" disabled={true}>Unidade de Lotação</Button>{' '}
            <Button onClick={() => navigate(-1)} variant="secondary">Cancelar</Button>{' '}
          </Form>
        </Col>
      </Row>

      {show ?
        <ToastCustomizado
          show={show}
          setShow={setShow}
          mensagem={mensagem && mensagem.texto ? mensagem.texto : undefined}
          tipo={mensagem && mensagem.tipo ? mensagem.tipo : ''}
          delay={mensagem.delay}
        />
        : null}

    </>

  )
}

export default AlterarUnidade